export const ROW_HEIGHT = 140;
export const COLUMN_GAP = 10;
export const NUM_OF_COLS = 1;
